import { useCallback, useRef, useState } from 'react';

import * as Types from './types';

export const useRecaptchaValidation: Types.IUseReCaptchaValidation = () => {
    const [isReCaptchaVisible, setIsReCaptchaVisible] = useState(false);
    const onExternalTokenValidateRef = useRef<Types.IUseReCaptchaValidationValidateCallback | null>(null);
    const onExternalTokenErrorRef = useRef<Types.IUseReCaptchaValidationValidateCallback | null>(null);
    const requestReCaptchaToken = useCallback(async () => {
        try {
            // wait for a token from ReCaptcha component within the form
            return await new Promise<{ token: string }>((resolve, reject) => {
                onExternalTokenValidateRef.current = resolve;
                onExternalTokenErrorRef.current = reject;
                // show ReCaptcha after callbacks are set
                setIsReCaptchaVisible(true);
            });
        } finally {
            setIsReCaptchaVisible(false);
        }
    }, []);
    const abortReCaptchaTokenRequest = useCallback(async () => {
        setIsReCaptchaVisible(false);
    }, []);
    const onReCaptchaTokenValidate = useCallback((token) => onExternalTokenValidateRef.current?.(token), []);
    const onReCaptchaTokenError = useCallback((error) => onExternalTokenErrorRef.current?.(error), []);

    return {
        isReCaptchaVisible,
        onReCaptchaTokenValidate,
        onReCaptchaTokenError,
        requestReCaptchaToken,
        abortReCaptchaTokenRequest
    };
};
